import { apple, play } from "../assets/Images";
import "../../../../src/App.css";
import Waitlist from "../../../components/navbar/Waitlist";
import SlideInOnScroll from "../assets/animations/SlideInScroll";

const HeroSection = () => {
  return (
    <div className="flex flex-col space-y-3 text-center justify-start items-center h-[850px] md:h-[1000px]  relative">
      <div className="mt-6">
        <h1 className="text-gray-400 md:text-5xl text-[30px]">Haircare AI</h1>
      </div>
      <div className="pt-2">
        <h1 className="text-gray-800  ubuntu-sans-h1 lg:text-[58px] text-[46px]  font-semibold">
          your personal hair care assistant
        </h1>
      </div>
      <div>
        <h1 className="text-gray-400 lg:font-bold font-normal text-[16px] lg:text-[18px]">
          Coming Soon
        </h1>
      </div>
      <div className="pt-2">
        <div className="flex z-50  md:flex-row flex-col items-center justify-center md:space-x-4 space-y-4 md:space-y-0">
          <div>
            <div className="flex flex-row items-center justify-center space-x-2 bg-gray-900 w-[200px] py-3 rounded-full">
              <div>
                <img src={apple} className="h-[20px] md:h-[28px]" alt="Logo" />
              </div>
              <div>
                <h1 className="font-semibold text-[13px] text-white">
                  App Store
                </h1>
              </div>
            </div>
          </div>
          <div>
            <div className="flex flex-row items-center justify-center space-x-2 bg-gray-900 w-[200px] py-3 rounded-full ">
              <div>
                <img src={play} className="h-[20px] md:h-[28px]" alt="Logo" />
              </div>
              <div>
                <h1 className="font-semibold text-[13px] text-white">
                  Google Play
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="pt-4 lg:pt-20 z-40">
        <Waitlist />
      </div>
      <div className="absolute w-full h-full z-10">
        <div className="w-full h-full relative">
          <div className="flex flex-row h-full  w-full items-end justify-between">
            <div>
              <img
                src="https://ik.imagekit.io/haircareai/man.png?updatedAt=1719821765655"
                loading="lazy"
                className="h-[340px] md:h-[750px]"
                alt="man"
              />
            </div>
            <div>
              <img
                src="https://ik.imagekit.io/haircareai/woman.png?updatedAt=1719821765731"
                loading="lazy"
                className="h-[340px] md:h-[750px]"
                alt="woman"
              />
            </div>
          </div>
          <div className="absolute lg:top-[520px] hidden lg:flex w-full space-y-6 flex-col justify-center items-center">
            <div>
              <img
                loading="lazy"
                src="https://ik.imagekit.io/haircareai/phoneMockup.png?updatedAt=1719821762609"
                className="h-[400px] md:h-[570px]"
                alt="Logo"
              />
            </div>
            <div>
              <h1 className="text-gray-400 w-[420px] text-center text-[22px]">
                Know and understand your{" "}
                <span className="font-bold">hair type</span> and its{" "}
                <span className="font-bold">unique</span> caring
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
